<template>
    <div class="customerServece">
        <div class="cServece">
            <div class="cModal">
                <p class="cTitle">联系客服</p>
                <p class="cText">扫描二维码，可添加官方微信号</p>
                <img class="cQrcode" src="../../static/images/qrcode.png" alt="">
            </div>
            <div @click="closeModal" class="cClose"></div>
        </div>
    </div>
</template>
<script>
export default {
  name: "CustomerServece",
  data() {
    return {};
  },
  methods: {
      closeModal(){
          
          this.$emit("closeCS",false);
      }
  },
  mounted() {}
};
</script>
<style scoped lang="scss" src="../../static/scss/customerservece.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>